document.addEventListener("DOMContentLoaded", () => {
  const selectTopic = document.getElementById("select-topic");
  const topicButtons = document.querySelectorAll(".topic-button");
  const contactSearch = document.querySelector("#contact-search");

  function showTopic(topic, isButton = false) {
    const selectedTopic = document.querySelector(`[data-id="${topic}"]`);
    if (selectedTopic) {
      // Hide all sibling topics
      selectedTopic.parentElement.querySelectorAll('[data-id]').forEach(el => {
        el.classList.add("hidden");
      });
      // Show the selected topic
      selectedTopic.classList.remove("hidden");

      // Handle button styling (only for button clicks)
      if (isButton) {
        // Remove styling from all buttons and their parent <li> elements
        topicButtons.forEach(btn => {
          btn.classList.remove('font-bold');
          btn.closest('li')?.classList.remove('bg-soft', 'rounded-lg');
        });
        // Add styling to the clicked button and its parent <li>
        const activeButton = document.getElementById(topic);
        if (activeButton) {
          activeButton.classList.add('font-bold');
          const activeButtonLi = activeButton.closest('li');
          if (activeButtonLi) {
            activeButtonLi.classList.add('bg-soft', 'rounded-lg');
          }
        }
      }
    }
  }

  selectTopic.addEventListener("change", () => showTopic(selectTopic.value));

  topicButtons.forEach(button => 
    button.addEventListener("click", () => showTopic(button.id, true))
  );

  contactSearch.addEventListener('input', function() {
      // Step 1: Add 'hidden' class to all elements with class 'contact-topics'
      const contactTopics = document.querySelectorAll('.contact-topics');
      contactTopics.forEach(topic => topic.classList.add('hidden'));

      // Step 2: Unhide the div with class 'contact-search'
      const contactSearchDiv = document.querySelector('.contact-search');
      if (contactSearchDiv) {
          contactSearchDiv.classList.remove('hidden');
      }

      // Step 3: Filter the list by the question title
      const searchValue = contactSearch.value.toLowerCase();
      const detailsElements = document.querySelectorAll('details.group');

      detailsElements.forEach(details => {
          const question = details.querySelector('summary').textContent.toLowerCase();
          if (question.includes(searchValue)) {
              details.classList.remove('hidden');
          } else {
              details.classList.add('hidden');
          }
      });
  });

});